import { TuiCountryIsoCode } from '@taiga-ui/i18n/enums';

const TUI_VIETNAMESE_LANGUAGE_ADDON_COMMERCE = {
    cardNumber: [`Số thẻ`, `Số thẻ`],
    cardExpiry: [`Hết hạn`, `Ngày hết hạn`],
};

const TUI_VIETNAMESE_LANGUAGE_ADDON_EDITOR = {
    colorSelectorModeNames: [`Màu thuần`, `Màu chuyển sắc`],
    toolbarTools: {
        undo: `Hoàn tác`,
        redo: `Làm lại`,
        font: `Phông chữ`,
        fontStyle: `Kiểu chữ`,
        fontSize: `Cỡ chữ`,
        bold: `In đậm`,
        italic: `In nghiêng`,
        underline: `Gạch chân`,
        strikeThrough: `Gạch ngang`,
        justify: `Canh lề`,
        justifyLeft: `Canh trái`,
        justifyCenter: `Canh giữa`,
        justifyRight: `Canh phải`,
        justifyFull: `Canh đều`,
        list: `Danh sách`,
        indent: `Thụt vào`,
        outdent: `Thụt ra`,
        unorderedList: `Danh sách không đánh số`,
        orderedList: `Danh sách được đánh số`,
        quote: `Trích dẫn`,
        foreColor: `Màu`,
        backColor: `Màu nền`,
        hiliteColor: `Màu đánh dấu`,
        clear: `Xóa`,
        link: `Liên kết`,
        attach: `Tệp đính kèm`,
        tex: `Chèn TeX`,
        code: `Đoạn mã`,
        image: `Chèn hình`,
        insertHorizontalRule: `Chèn thước ngang`,
        superscript: `Chỉ số trên`,
        subscript: `Chỉ số dưới`,
        insertTable: `Chèn bảng`,
        hiliteGroup: `Hilite group`,
        insertGroup: `Chèn nhóm`,
        removeGroup: `Xóa nhóm`,
        insertAnchor: `Chèn mỏ neo`,
        mergeCells: `Hợp nhất ô`,
        splitCells: `Tách ô`,
        rowsColumnsManaging: `Quản lý hàng và cột`,
        cellColor: `Màu ô`,
        setDetails: `Chi tiết`,
        removeDetails: `Hủy chi tiết`,
    },
    editorEditLink: {
        urlExample: `example.com`,
        anchorExample: `anchor`,
    },
    editorTableCommands: [
        [`Chèn cột trước`, `Chèn cột sau`],
        [`Chèn hàng trước`, `Chèn hàng sau`],
        [`Xóa cột`, `Xóa hàng`],
    ],
    editorCodeOptions: [`Mã trong dòng`, `Mã trong khối`],
    editorFontOptions: {
        small: `Nhỏ`,
        normal: `Thường`,
        large: `Lớn`,
        title: `Tiêu đề`,
        subtitle: `Phụ đề`,
    },
};

const TUI_VIETNAMESE_LANGUAGE_ADDON_PREVIEW = {
    previewTexts: {
        rotate: `Xoay`,
    },
    zoomTexts: {
        zoomOut: `Thu nhỏ`,
        zoomIn: `Phóng to`,
        reset: `Đặt lại`,
    },
};

const TUI_VIETNAMESE_LANGUAGE_ADDON_TABLE = {
    showHideText: `Hiện/Ẩn`,
    paginationTexts: {
        pages: `Tổng số trang`,
        linesPerPage: `Số dòng mỗi trang`,
        of: `trên`,
    },
};

const TUI_VIETNAMESE_LANGUAGE_COUNTRIES = {
    [TuiCountryIsoCode.AD]: `Andorra`,
    [TuiCountryIsoCode.AE]: `Các tiểu Vương quốc Ả Rập Thống nhất`,
    [TuiCountryIsoCode.AF]: `Afghanistan`,
    [TuiCountryIsoCode.AG]: `Antigua và Barbuda`,
    [TuiCountryIsoCode.AI]: `Anguilla`,
    [TuiCountryIsoCode.AL]: `Albania`,
    [TuiCountryIsoCode.AM]: `Armenia`,
    [TuiCountryIsoCode.AO]: `Angola`,
    [TuiCountryIsoCode.AR]: `Argentina`,
    [TuiCountryIsoCode.AT]: `Áo`,
    [TuiCountryIsoCode.AU]: `Úc`,
    [TuiCountryIsoCode.AW]: `Aruba`,
    [TuiCountryIsoCode.AZ]: `Azerbaijan`,
    [TuiCountryIsoCode.BA]: `Bosnia và Herzegovina`,
    [TuiCountryIsoCode.BB]: `Barbados`,
    [TuiCountryIsoCode.BD]: `Bangladesh`,
    [TuiCountryIsoCode.BE]: `Bỉ`,
    [TuiCountryIsoCode.BF]: `Burkina Faso`,
    [TuiCountryIsoCode.BG]: `Bulgaria`,
    [TuiCountryIsoCode.BH]: `Bahrain`,
    [TuiCountryIsoCode.BI]: `Burundi`,
    [TuiCountryIsoCode.BJ]: `Benin`,
    [TuiCountryIsoCode.BL]: `Saint Barthélemy`,
    [TuiCountryIsoCode.BM]: `Bermuda`,
    [TuiCountryIsoCode.BN]: `Brunei`,
    [TuiCountryIsoCode.BO]: `Bolivia`,
    [TuiCountryIsoCode.BQ]: `Bonaire, Sint Eustatius và Saba`,
    [TuiCountryIsoCode.BR]: `Brazil`,
    [TuiCountryIsoCode.BS]: `Bahamas`,
    [TuiCountryIsoCode.BT]: `Bhutan`,
    [TuiCountryIsoCode.BW]: `Botswana`,
    [TuiCountryIsoCode.BY]: `Belarus`,
    [TuiCountryIsoCode.BZ]: `Belize`,
    [TuiCountryIsoCode.CA]: `Canada`,
    [TuiCountryIsoCode.CD]: `Cộng hoà dân chủ Congo`,
    [TuiCountryIsoCode.CF]: `Cộng hoà Trung Phi`,
    [TuiCountryIsoCode.CG]: `Cộng hoà Congo`,
    [TuiCountryIsoCode.CH]: `Thụy Sĩ`,
    [TuiCountryIsoCode.CI]: `Bờ Biển Ngà`,
    [TuiCountryIsoCode.CL]: `Chile`,
    [TuiCountryIsoCode.CM]: `Cameroon`,
    [TuiCountryIsoCode.CN]: `Trung Quốc`,
    [TuiCountryIsoCode.CO]: `Colombia`,
    [TuiCountryIsoCode.CR]: `Costa Rica`,
    [TuiCountryIsoCode.CU]: `Cuba`,
    [TuiCountryIsoCode.CV]: `Cape Verde`,
    [TuiCountryIsoCode.CW]: `Curaçao`,
    [TuiCountryIsoCode.CY]: `Síp`,
    [TuiCountryIsoCode.CZ]: `Cộng hòa Séc`,
    [TuiCountryIsoCode.DE]: `Đức`,
    [TuiCountryIsoCode.DJ]: `Djibouti`,
    [TuiCountryIsoCode.DK]: `Đan Mạch`,
    [TuiCountryIsoCode.DM]: `Dominica`,
    [TuiCountryIsoCode.DO]: `Cộng hoà Dominica`,
    [TuiCountryIsoCode.DZ]: `Algeria`,
    [TuiCountryIsoCode.EC]: `Ecuador`,
    [TuiCountryIsoCode.EE]: `Estonia`,
    [TuiCountryIsoCode.EG]: `Ai Cập`,
    [TuiCountryIsoCode.ER]: `Eritrea`,
    [TuiCountryIsoCode.ES]: `Tây Ban Nha`,
    [TuiCountryIsoCode.ET]: `Ethiopia`,
    [TuiCountryIsoCode.FI]: `Phần Lan`,
    [TuiCountryIsoCode.FJ]: `Fiji`,
    [TuiCountryIsoCode.FK]: `Quần đảo Falkland`,
    [TuiCountryIsoCode.FM]: `Liên bang Micronesia`,
    [TuiCountryIsoCode.FR]: `Pháp`,
    [TuiCountryIsoCode.GA]: `Gabon`,
    [TuiCountryIsoCode.GB]: `Vương quốc Anh`,
    [TuiCountryIsoCode.GD]: `Grenada`,
    [TuiCountryIsoCode.GE]: `Georgia`,
    [TuiCountryIsoCode.GF]: `Guyana`,
    [TuiCountryIsoCode.GH]: `Ghana`,
    [TuiCountryIsoCode.GI]: `Gibraltar`,
    [TuiCountryIsoCode.GL]: `Greenland`,
    [TuiCountryIsoCode.GM]: `Gambia`,
    [TuiCountryIsoCode.GN]: `Guinea`,
    [TuiCountryIsoCode.GP]: `Guadeloupe`,
    [TuiCountryIsoCode.GQ]: `Guinea Xích đạo`,
    [TuiCountryIsoCode.GR]: `Hy Lạp`,
    [TuiCountryIsoCode.GT]: `Guatemala`,
    [TuiCountryIsoCode.GW]: `Guinea-Bissau`,
    [TuiCountryIsoCode.GY]: `Guyana`,
    [TuiCountryIsoCode.HK]: `Hồng Kông`,
    [TuiCountryIsoCode.HN]: `Honduras`,
    [TuiCountryIsoCode.HR]: `Croatia`,
    [TuiCountryIsoCode.HT]: `Haiti`,
    [TuiCountryIsoCode.HU]: `Hungary`,
    [TuiCountryIsoCode.ID]: `Indonesia`,
    [TuiCountryIsoCode.IE]: `Ireland`,
    [TuiCountryIsoCode.IL]: `Israel`,
    [TuiCountryIsoCode.IN]: `Ấn Độ`,
    [TuiCountryIsoCode.IQ]: `Iraq`,
    [TuiCountryIsoCode.IR]: `Iran`,
    [TuiCountryIsoCode.IS]: `Iceland`,
    [TuiCountryIsoCode.IT]: `Italy`,
    [TuiCountryIsoCode.JM]: `Jamaica`,
    [TuiCountryIsoCode.JO]: `Jordan`,
    [TuiCountryIsoCode.JP]: `Nhật Bản`,
    [TuiCountryIsoCode.KE]: `Kenya`,
    [TuiCountryIsoCode.KG]: `Kyrgyzstan`,
    [TuiCountryIsoCode.KH]: `Campuchia`,
    [TuiCountryIsoCode.KM]: `Comoros`,
    [TuiCountryIsoCode.KN]: `Saint Kitts và Nevis`,
    [TuiCountryIsoCode.KP]: `Triều Tiên`,
    [TuiCountryIsoCode.KR]: `Hàn Quốc`,
    [TuiCountryIsoCode.KW]: `Kuwait`,
    [TuiCountryIsoCode.KY]: `Quần đảo Cayman`,
    [TuiCountryIsoCode.KZ]: `Kazakhstan`,
    [TuiCountryIsoCode.LA]: `Lào`,
    [TuiCountryIsoCode.LB]: `Lebanon`,
    [TuiCountryIsoCode.LC]: `Saint Lucia`,
    [TuiCountryIsoCode.LI]: `Liechtenstein`,
    [TuiCountryIsoCode.LK]: `Sri Lanka`,
    [TuiCountryIsoCode.LR]: `Liberia`,
    [TuiCountryIsoCode.LS]: `Lesotho`,
    [TuiCountryIsoCode.LT]: `Litva`,
    [TuiCountryIsoCode.LU]: `Luxembourg`,
    [TuiCountryIsoCode.LV]: `Latvia`,
    [TuiCountryIsoCode.LY]: `Libya`,
    [TuiCountryIsoCode.MA]: `Ma Rốc`,
    [TuiCountryIsoCode.MC]: `Monaco`,
    [TuiCountryIsoCode.MD]: `Moldova`,
    [TuiCountryIsoCode.ME]: `Montenegro`,
    [TuiCountryIsoCode.MF]: `Saint Martin`,
    [TuiCountryIsoCode.MG]: `Madagascar`,
    [TuiCountryIsoCode.MK]: `Bắc Macedonia`,
    [TuiCountryIsoCode.ML]: `Mali`,
    [TuiCountryIsoCode.MM]: `Myanmar`,
    [TuiCountryIsoCode.MN]: `Mông Cổ`,
    [TuiCountryIsoCode.MO]: `Ma Cao`,
    [TuiCountryIsoCode.MQ]: `Martinique`,
    [TuiCountryIsoCode.MR]: `Mauritania`,
    [TuiCountryIsoCode.MS]: `Montserrat`,
    [TuiCountryIsoCode.MT]: `Malta`,
    [TuiCountryIsoCode.MU]: `Mauritius`,
    [TuiCountryIsoCode.MV]: `Maldives`,
    [TuiCountryIsoCode.MW]: `Malawi`,
    [TuiCountryIsoCode.MX]: `Mexico`,
    [TuiCountryIsoCode.MY]: `Malaysia`,
    [TuiCountryIsoCode.MZ]: `Mozambique`,
    [TuiCountryIsoCode.NA]: `Namibia`,
    [TuiCountryIsoCode.NC]: `Nouvelle-Calédonie`,
    [TuiCountryIsoCode.NE]: `Niger`,
    [TuiCountryIsoCode.NG]: `Nigeria`,
    [TuiCountryIsoCode.NI]: `Nicaragua`,
    [TuiCountryIsoCode.NL]: `Hà Lan`,
    [TuiCountryIsoCode.NO]: `Na Uy`,
    [TuiCountryIsoCode.NP]: `Nepal`,
    [TuiCountryIsoCode.NZ]: `New Zealand`,
    [TuiCountryIsoCode.OM]: `Oman`,
    [TuiCountryIsoCode.PA]: `Panama`,
    [TuiCountryIsoCode.PE]: `Peru`,
    [TuiCountryIsoCode.PF]: `Polynesia thuộc Pháp (Tahiti)`,
    [TuiCountryIsoCode.PG]: `Papua New Guinea`,
    [TuiCountryIsoCode.PH]: `Philippines`,
    [TuiCountryIsoCode.PK]: `Pakistan`,
    [TuiCountryIsoCode.PL]: `Ba Lan`,
    [TuiCountryIsoCode.PT]: `Bồ Đào Nha`,
    [TuiCountryIsoCode.PW]: `Palau`,
    [TuiCountryIsoCode.PY]: `Paraguay`,
    [TuiCountryIsoCode.QA]: `Qatar`,
    [TuiCountryIsoCode.RE]: `Réunion`,
    [TuiCountryIsoCode.RO]: `Romania`,
    [TuiCountryIsoCode.RS]: `Serbia`,
    [TuiCountryIsoCode.RU]: `Nga`,
    [TuiCountryIsoCode.RW]: `Rwanda`,
    [TuiCountryIsoCode.SA]: `Ả Rập Xê-út`,
    [TuiCountryIsoCode.SB]: `Quần đảo Solomon`,
    [TuiCountryIsoCode.SC]: `Seychelles`,
    [TuiCountryIsoCode.SD]: `Sudan`,
    [TuiCountryIsoCode.SE]: `Thụy Điển`,
    [TuiCountryIsoCode.SG]: `Singapore`,
    [TuiCountryIsoCode.SH]: `Saint Helena`,
    [TuiCountryIsoCode.SI]: `Slovenia`,
    [TuiCountryIsoCode.SK]: `Slovakia`,
    [TuiCountryIsoCode.SL]: `Sierra Leone`,
    [TuiCountryIsoCode.SM]: `San Marino`,
    [TuiCountryIsoCode.SN]: `Senegal`,
    [TuiCountryIsoCode.SO]: `Somalia`,
    [TuiCountryIsoCode.SR]: `Suriname`,
    [TuiCountryIsoCode.ST]: `Sao Tome và Principe`,
    [TuiCountryIsoCode.SV]: `El Salvador`,
    [TuiCountryIsoCode.SX]: `Sint Maarten`,
    [TuiCountryIsoCode.SY]: `Syria`,
    [TuiCountryIsoCode.SZ]: `Swaziland`,
    [TuiCountryIsoCode.TC]: `Turks và Caicos`,
    [TuiCountryIsoCode.TD]: `Chad`,
    [TuiCountryIsoCode.TG]: `Togo`,
    [TuiCountryIsoCode.TH]: `Thái Lan`,
    [TuiCountryIsoCode.TJ]: `Tajikistan`,
    [TuiCountryIsoCode.TL]: `Timor-Leste`,
    [TuiCountryIsoCode.TM]: `Turkmenistan`,
    [TuiCountryIsoCode.TN]: `Tunisia`,
    [TuiCountryIsoCode.TO]: `Tonga`,
    [TuiCountryIsoCode.TR]: `Thổ Nhĩ Kỳ`,
    [TuiCountryIsoCode.TT]: `Trinidad và Tobago`,
    [TuiCountryIsoCode.TW]: `Đài Loan`,
    [TuiCountryIsoCode.TZ]: `Tanzania`,
    [TuiCountryIsoCode.UA]: `Ukraina`,
    [TuiCountryIsoCode.UG]: `Uganda`,
    [TuiCountryIsoCode.US]: `Hoa Kỳ`,
    [TuiCountryIsoCode.UY]: `Uruguay`,
    [TuiCountryIsoCode.UZ]: `Uzbekistan`,
    [TuiCountryIsoCode.VC]: `Saint Vincent và Grenadines`,
    [TuiCountryIsoCode.VE]: `Venezuela`,
    [TuiCountryIsoCode.VG]: `Quần đảo Virgin thuộc Anh`,
    [TuiCountryIsoCode.VN]: `Việt Nam`,
    [TuiCountryIsoCode.VU]: `Vanuatu`,
    [TuiCountryIsoCode.WS]: `Samoa`,
    [TuiCountryIsoCode.XK]: `Kosovo`,
    [TuiCountryIsoCode.YE]: `Yemen`,
    [TuiCountryIsoCode.YT]: `Mayotte`,
    [TuiCountryIsoCode.ZA]: `Nam Phi`,
    [TuiCountryIsoCode.ZM]: `Zambia`,
    [TuiCountryIsoCode.ZW]: `Zimbabwe`,
};

const TUI_VIETNAMESE_LANGUAGE_CORE = {
    months: [
        `Tháng 1`,
        `Tháng 2`,
        `Tháng 3`,
        `Tháng 4`,
        `Tháng 5`,
        `Tháng 6`,
        `Tháng 7`,
        `Tháng 8`,
        `Tháng 9`,
        `Tháng 10`,
        `Tháng 11`,
        `Tháng 12`,
    ],
    close: `Đóng`,
    nothingFoundMessage: `Không tìm thấy`,
    defaultErrorMessage: `Giá trị không hợp lệ`,
    spinTexts: [`Trước`, `Sau`],
    shortWeekDays: [`T2`, `T3`, `T4`, `T5`, `T6`, `T7`, `CN`],
    countries: TUI_VIETNAMESE_LANGUAGE_COUNTRIES,
};

const TUI_VIETNAMESE_LANGUAGE_KIT = {
    cancel: `Hủy bỏ`,
    done: `Hoàn thành`,
    more: `Thêm`,
    otherDate: `Ngày khác...`,
    showAll: `Hiển thị tất cả`,
    hide: `Ẩn`,
    mobileCalendarTexts: [`Chọn ngày`, `Chọn phạm vi`],
    range: [`từ`, `đến`],
    countTexts: [`Cộng`, `Trừ`],
    time: {
        'HH:MM': `HH:MM`,
        'HH:MM:SS': `HH:MM:SS`,
        'HH:MM:SS.MSS': `HH:MM:SS.MSS`,
    },
    dateTexts: {
        DMY: `dd.mm.yyyy`,
        MDY: `mm.dd.yyyy`,
        YMD: `yyyy.mm.dd`,
    },
    digitalInformationUnits: [`B`, `KiB`, `MiB`],
    passwordTexts: [`Hiện mật khẩu`, `Ẩn mật khẩu`],
    copyTexts: [`Sao chép`, `Đã sao chép`],
    shortCalendarMonths: [
        `Thg 1`,
        `Thg 2`,
        `Thg 3`,
        `Thg 4`,
        `Thg 5`,
        `Thg 6`,
        `Thg 7`,
        `Thg 8`,
        `Thg 9`,
        `Thg 10`,
        `Thg 11`,
        `Thg 12`,
    ],
    pagination: [`Trang trước`, `Trang sau`],
    fileTexts: {
        loadingError: `Lỗi tải`,
        preview: `Xem trước`,
        remove: `Gỡ bỏ`,
    },
    inputFileTexts: {
        defaultLabelSingle: `hoặc kéo nó vào đây`,
        defaultLabelMultiple: `hoặc kéo nó vào đây`,
        defaultLinkSingle: `Chọn một tệp`,
        defaultLinkMultiple: `Chọn nhiều tệp`,
        maxSizeRejectionReason: `Tệp vượt quá kích thước `,
        formatRejectionReason: `Tệp sai định dạng`,
        drop: `Thả tệp tại đây`,
        dropMultiple: `Thả nhiều tệp tại đây`,
    },
    multiSelectTexts: {
        all: `Chọn tất cả`,
        none: `Không chọn`,
    },
    prompt: {
        yes: `Đúng`,
        no: `Không`,
    },
};

const TUI_VIETNAMESE_LANGUAGE = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ name: `vietnamese` }, TUI_VIETNAMESE_LANGUAGE_CORE), TUI_VIETNAMESE_LANGUAGE_KIT), TUI_VIETNAMESE_LANGUAGE_ADDON_TABLE), TUI_VIETNAMESE_LANGUAGE_ADDON_COMMERCE), TUI_VIETNAMESE_LANGUAGE_ADDON_EDITOR), TUI_VIETNAMESE_LANGUAGE_ADDON_PREVIEW);

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_VIETNAMESE_LANGUAGE, TUI_VIETNAMESE_LANGUAGE_ADDON_COMMERCE, TUI_VIETNAMESE_LANGUAGE_ADDON_EDITOR, TUI_VIETNAMESE_LANGUAGE_ADDON_PREVIEW, TUI_VIETNAMESE_LANGUAGE_ADDON_TABLE, TUI_VIETNAMESE_LANGUAGE_CORE, TUI_VIETNAMESE_LANGUAGE_COUNTRIES, TUI_VIETNAMESE_LANGUAGE_KIT };
